const items = [
  "BBL NATURAL SCULPT",
  "DRAINAGE LYMPHATIQUE",
  "ANTI BURN-OUT",
  "ÉLASTIQUES LAGIGAFAM",
  "SPORT FITNESS ISLAND",
  "BY PERLE LAMA",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <section
      data-testid="marquee"
      className="relative py-10 md:py-14 bg-pink-600 overflow-hidden border-y-4 border-neutral-900"
    >
      <div className="flex marquee-track whitespace-nowrap">
        {row.map((t, i) => (
          <span
            key={i}
            className="font-display text-4xl md:text-6xl font-black uppercase tracking-tight text-white mx-8 flex items-center gap-8"
          >
            {t}
            <span className="text-yellow-300 text-5xl">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
}
